const envApiBaseUrl = process.env.REACT_APP_API_BASE_URL || "";

function resolveProductionApiBaseUrl() {
  if (typeof window === "undefined") {
    return envApiBaseUrl;
  }

  const hostname = window.location.hostname;
  if (/^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) {
    return envApiBaseUrl;
  }
  if (hostname === "localhost" || hostname.endsWith(".local")) {
    return envApiBaseUrl;
  }

  const parts = hostname.split(".");
  if (parts.length < 3) {
    return envApiBaseUrl;
  }

  const first = parts[0];
  const rest = parts.slice(1).join(".");
  const apiHost = `${first}-api.${rest}`;
  const protocol = window.location.protocol === "https:" ? "https:" : "http:";
  return `${protocol}//${apiHost}`;
}

function resolveApiBaseUrl() {
  if (process.env.NODE_ENV !== "production") {
    return envApiBaseUrl;
  }
  return resolveProductionApiBaseUrl();
}

export const API_BASE_URL = resolveApiBaseUrl();
